import {HoistProps, creates, hoistCmp} from '@xh/hoist/core';
import {IndicatorPickerModel} from './IndicatorPickerModel';
import {popover} from '@xh/hoist/kit/blueprint';
import {Icon} from '@xh/hoist/icon';
import {storeFilterField} from '@xh/hoist/cmp/store';
import {grid} from '@xh/hoist/cmp/grid';
import {fragment, span, vbox} from '@xh/hoist/cmp/layout';
import './IndicatorPicker.scss';
import {compactToolbarButton} from '../../../cmp/toolbar/Toolbar';

interface IndicatorPickerProps extends HoistProps<IndicatorPickerModel> {
    indicatorValue: string;
    onValueChange?: (value: string) => void;
}
export const indicatorPicker = hoistCmp.factory<IndicatorPickerProps>({
    model: creates(IndicatorPickerModel),
    render({model, ...props}) {
        return fragment(
            popover({
                interactionKind: 'click',
                targetProps: {className: 'square-button-target'},
                onInteraction: state => {
                    if (!state) model.close();
                },
                item: compactToolbarButton({
                    icon: Icon.func(),
                    tooltip: 'Technical Indicators',
                    onClick: () => model.open()
                }),
                isOpen: model.isOpen,
                content: vbox(
                    storeFilterField({
                        model: model.indicatorGrid,
                        width: 400,
                        placeholder: 'Filter Indicators...',
                        matchMode: 'any'
                    }),
                    grid({
                        model: model.indicatorGrid,
                        width: 300,
                        height: 400
                    })
                )
            }),
            span({className: 'indicator-picker__label', item: model.indicatorDescription})
        );
    }
});
